import visitorConstants from "@/constants/visitorConstants"

const pages = {
  settingsPage() {
    return {
      name: "Visitor Settings",
      i18n_name_key: "sidebar_items.visitor_settings",
      path: visitorConstants.PATHS.SETTINGS,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.SETTINGS
    }
  },
  adultsPage() {
    return {
      name: "Visitor Adults",
      i18n_name_key: "sidebar_items.visitor_adults",
      path: visitorConstants.PATHS.ADULTS,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.ADULTS,
      helpKey: "visitor_adults",
      action: {
        assign: {
          title: "Assign (Add staff)",
          modalTitle: "Assign adults who can check in visitors"
        }
      }
    }
  },
  guardianStudentMatrixPage() {
    return {
      name: "Visitor Guardian/Student Matrix",
      i18n_name_key: "sidebar_items.visitor_guardian_student_matrix",
      path: visitorConstants.PATHS.GUARDIAN_STUDENT_MATRIX,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.GUARDIAN_STUDENT_MATRIX,
      helpKey: "visitor_guardian_student_matrix"
    }
  },
  securityPage() {
    return {
      name: "Security Alerts",
      i18n_name_key: "sidebar_items.security_alerts_settings",
      path: visitorConstants.PATHS.SECURITY,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.SECURITY,
      helpKey: "visitor_security_settings_0002"
    }
  },
  kioskPage() {
    return {
      name: "Kiosk Settings",
      i18n_name_key: "sidebar_items.kiosk_settings",
      path: visitorConstants.PATHS.KIOSK,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.KIOSK,
      helpKey: "visitor_kiosk_settings"
    }
  },
  generalPage() {
    return {
      name: "General Settings",
      i18n_name_key: "sidebar_items.general_settings",
      path: visitorConstants.PATHS.GENERAL,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.GENERAL,
      helpKey: "visitor_general_settings"
    }
  },
  listPage() {
    return {
      name: "List Settings",
      i18n_name_key: "sidebar_items.list_settings",
      path: visitorConstants.PATHS.LIST,
      roles: visitorConstants.VISITOR_ADMIN_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.LIST,
      helpKey: "visitor_list_settings"
    }
  },
  managementPage() {
    return {
      name: "Visitor Management",
      i18n_name_key: "sidebar_items.visitor_management",
      path: visitorConstants.PATHS.MANAGEMENT,
      roles: visitorConstants.VISITOR_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.MANAGEMENT
    }
  },
  checkInLogsPage() {
    return {
      name: "Check-ins Reports",
      i18n_name_key: "sidebar_items.check_ins_and_reports",
      path: visitorConstants.PATHS.CHECK_IN_LOGS,
      roles: visitorConstants.VISITOR_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.CHECK_IN_LOGS,
      helpKey: "visitor_check_in_v01"
    }
  },
  printerPage() {
    return {
      name: "Printer Setup",
      i18n_name_key: "sidebar_items.printer_setup",
      path: visitorConstants.PATHS.PRINTER,
      roles: visitorConstants.VISITOR_ROLES,
      module: visitorConstants.MODULE,
      dependency: visitorConstants.ROUTE_DEPENDENCY.PRINTER,
      helpKey: "visitor_printer_settings"
    }
  }
}

const useCustomVisitorTimeFunction = true

export default {
  pages,
  useCustomVisitorTimeFunction
}
